var s4 = function() {
	return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
};
function generateType1() {
	return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
};

function generateType2() {
	return ('w'+s4()+s4()+s4()+s4());
}

function generateType3() {
	return ('w'+s4());
}


function debounce(fn, delay) {
	'use strict';
	var timer = null;
	return function () {
		var context = this, args = arguments;
		clearTimeout(timer);
		timer = setTimeout(function () {
			fn.apply(context, args);
		}, delay);
	};
}

function throttle(fn, threshhold, scope) {
	'use strict';
	threshhold = threshhold || 250;
	var last, deferTimer;
	return function () {
		var context = scope || this;

		var now = +(new Date()),
		args = arguments;
		if (last && now < last + threshhold) {
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function () {
				last = now;
				fn.apply(context, args);
			}, threshhold);
		} else {
			last = now;
			fn.apply(context, args);
		}
	};
}

//////////////////// Utility ////////////////////
function isString(value){return typeof value === 'string';}
function isNumber(value){return typeof value === 'number';}
function isDateTime(value){
	return /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}\+\d{4}/.test(value);
}
function isObject(value){return typeof value === 'object';}

// var FIELD_PLACEHOLDER_REGEX = /\B\$(\w)+/g
var FIELD_PLACEHOLDER_REGEX = /\B\$([\A-z\d\u0370-\u1FFF\u2C00-\uFFEF\s])+\$/g;

/**
 * @function
 * @name fieldPlaceholder -> simpleTemplate
 *
 * @description
 *	```
 *	serviceUtility.fieldPlaceholder.simpleTemplate('table $table$ | search value == "$keyword$"', { table: 'wc44', keyword: 'hello' });
 *	// -> table wc44 | search value == "hello"
 *	```
 * @param {String} query 쿼리 스트링
 * @param {Object} pairs 키/값 쌍
 * @returns {String} 쿼리 스트링내에 doller sign 으로 감싸진 부분들, 즉 placeholder key를 키/값 쌍으로부터 값을 얻어와 변환합니다.
 */
function simpleTemplateForFieldPlaceholder(str, keys) {
	return str.replace(FIELD_PLACEHOLDER_REGEX, function(key) {
		var value = keys[key.substr(1,key.length - 2)];
		return isEmpty(value) ? '' : value;
	});
}

/**
 * @function
 * @name fieldPlaceholder -> extract
 *
 * @description
 *	```
 *	serviceUtility.fieldPlaceholder.extract('table $table$ | search value == "$keyword$"');
 *	// -> ["table", "keyword"]
 *  serviceUtility.fieldPlaceholder.extract('table $table$ | search value == "$테 스트$" | eval c = "$关于百度$" | eval k = "~$ウェブ$~"');
 *	// -> ["table", "테 스트", "关于百度", "ウェブ"]
 *	```
 * @param {String} query 쿼리 스트링
 * @returns {Array<String>} 쿼리 스트링내에 doller sign 으로 감싸진 부분들, 즉 placeholder key를 리턴합니다.
 */
function extractFieldPlaceholder(string) {
	if(typeof string == 'undefined') {
		return [];
	}

	var matches = string.match(FIELD_PLACEHOLDER_REGEX);
	if(angular.isArray(matches)) {
		return string.match(FIELD_PLACEHOLDER_REGEX).map(function(bracedCol) {
			return bracedCol.substr(1, bracedCol.length - 2);
		});
	}
	else return [];
}

function getColumnType(jsonArray) {
	// var jsonArray = JSON.parse(data);
	var allkeys = [];
	jsonArray.forEach(function(obj) {
		for(var prop in obj) {
			if(!~allkeys.indexOf(prop)) {
				allkeys.push(prop);
			}
		}
	});

	return allkeys.map(function(key) {
		var oc = jsonArray.every(function(obj) { return isObject(obj[key]) || (obj[key] === null || obj[key] === undefined); });
		var nc = jsonArray.every(function(obj) { return isNumber(obj[key]) || (obj[key] === null || obj[key] === undefined); });
		var dc = jsonArray.every(function(obj) { return isDateTime(obj[key]) || (obj[key] === null || obj[key] === undefined); });

		if(oc) {
			return {
				'type': 'object',
				'key': key
			}
		}
		else if(nc) {
			return {
				'type': 'number',
				'key': key
			}
		}
		else if(dc) {
			return {
				'type': 'datetime',
				'key': key
			}
		}
		else {
			return {
				'type': 'string',
				'key': key
			}
		}
	});
}

 /**
  * @function
  * @name isEmpty
  *
  * @description null, undefined 이면 true를 리턴합니다.
  *	```
  * serviceUtility.isEmpty(value)
  *	```
  * @param {*} value 종류에 관계없는 타입의 변수
  * @returns {boolean} true or false
  *
  */
function isEmpty(value) {
	return (typeof value === 'undefined' || value === null) ? true : false;
}

function convertHexToRgba(hex,opacity){
	hex = hex.replace('#','');
	var r = parseInt(hex.substring(0,2), 16);
	var g = parseInt(hex.substring(2,4), 16);
	var b = parseInt(hex.substring(4,6), 16);

	var result = 'rgba('+r+','+g+','+b+','+opacity/100+')';
	return result;
}

/**
 * @function
 * @name getUnique
 *
 * @description
 *	```
 * serviceUtility.getUnique(value, index, self)
 *	```
 * @param {}
 * @returns {}
 *
 *  //usage example:
 *	var a = ['a', 1, 'a', 2, '1'];
 *	var unique = a.filter( getUnique ); // returns ['a', 1, 2, '1']
 */
function getUnique(value, index, self) {
	return self.indexOf(value) === index;
}

/**
 * object array에서 property를 기준으로 한 unique한 배열을 리턴
 * @param  {[type]} arr object array
 * @param  {[type]} prop 배열 안의 object에서 기준이 될 property
 * @return {[type]}      property를 기준으로 한 unique한 배열
 */
function getUniqueArr(arr, prop) {
	var new_arr = [];
	var lookup  = {};
	for (var i in arr) {
		lookup[arr[i][prop]] = arr[i];
	}
	for (i in lookup) {
		new_arr.push(lookup[i]);
	}
	return new_arr;
}


/**
 * @function
 * @name getNamespace
 *
 * @description
 *	```
 *	serviceUtility.getNamespace('LOGPRESSO.process.getPid', window);
 *	// -> function getPid() { ... }
 *	```
 * @param {String} namespace 네임스페이스
 * @param {String} root root object 입니다. 전역객체로부터 탐색하려면 window 를 넘깁니다.
 * @returns {Object} 네임스페이스로 탐색한 항목을 리턴합니다. 없으면 null이 됩니다.
 */
function getNamespace(namespace, root) {
	var tokens = namespace.split('.');
	return tokens.reduce(function(prev, curr) {
		return (typeof prev == "undefined") ? prev : prev[curr];
	}, root);
}

/**
 * @function
 * @name exist
 *
 * @description
 *	```
 *	serviceUtility.exists('LOGPRESSO.process.getPid', window);
 *	// -> true
 *	```
 * @param {String} namespace 네임스페이스
 * @param {String} root root object 입니다. 전역객체로부터 탐색하려면 window 를 넘깁니다.
 * @returns {Boolean} 존재 여부를 리턴합니다.
 */
function exists(namespace, root) {
	return typeof getNamespace(namespace, root) !== 'undefined';
}

module.exports = {
	generateType1: generateType1,
	generateType2: generateType2,
	generateType3: generateType3,
	getColumnType: getColumnType,
	fieldPlaceholder: {
		extract: extractFieldPlaceholder,
		simpleTemplate: simpleTemplateForFieldPlaceholder
	},
	getNamespace: getNamespace,
	exists: exists,
	convertHexToRgba: convertHexToRgba,
	debounce: debounce,
	throttle: throttle,
	getUnique: getUnique,
	getUniqueArr: getUniqueArr,
	isEmpty: isEmpty,
}


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/Utility.js